import { useId } from 'react';
import cn from '../../utils/cn';

export type InputProps = {
  label?: string;
  name?: string;
  value: string;
  setValue: (value: string) => void;
  placeholder?: string;
  className?: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function Input({
  label,
  name,
  value,
  setValue,
  placeholder,
  className,
}: InputProps) {
  const id = useId();

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label htmlFor={id} className="text-sm font-bold">
          {label}
        </label>
      )}

      <input
        id={id}
        name={name}
        className="block w-full rounded-lg border px-3 py-1.5 leading-[18px] focus:border-brand-500"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
